module.exports = __webpack_public_path__ + "img/Icon-feather-edit.af29ab42.svg";